































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

type PropColorsSwitch = {
    checked: string;
    unchecked: string;
    disabled: string;
}

type PropTextsSwitch = {
    checked: string;
    unchecked: string;
}

@Component({
  name: 'SwitchToggle'
})
export default class SwitchToggle extends Vue {
    @Prop() readonly label!: string
    @Prop({ default: false }) readonly required!: boolean
    @Prop({ default: false }) readonly disabled!: boolean
    @Prop({ default: '' }) readonly id!: string | number
    @Prop({ default: '' }) readonly name!: string
    @Prop({ default: '' }) readonly className!: string
    @Prop({ default: '' }) readonly iconClass!: string
    @Prop({ default: '' }) readonly default!: string
    @Prop({ default: '' }) readonly msgError!: string
    @Prop({ default: 55 }) readonly width!: string
    @Prop({ default: null }) readonly hasError!: boolean|null
    @Prop({ type: Object, default: () => ({ checked: '#1f3960', unchecked: '#343a40', disabled: '#CCCCCC' }) }) colors!: PropColorsSwitch
    @Prop({ type: Object, default: () => ({ checked: 'SI', unchecked: 'NO' }) }) texts!: PropTextsSwitch

	value = this.default

    @Watch('default', { immediate: true, deep: true })
    changeOptions (newValue: string, oldValue: string) {
        if (newValue !== oldValue) {
            this.value = this.default
            this.$emit('input', this.value)
        }
    }
}
